import axios from 'axios';
import Botpoison from '@botpoison/browser';

const FORMSPARK_ENDPOINT = 'https://submit-form.com/QGV1NUl3h';

const botpoison = new Botpoison({
  publicKey: 'pk_93ee684e-a212-4c1e-9233-a539ae8c40d4'
});

export const submitFormspark = async (payload) => {
  const { solution } = await botpoison.challenge();

  return axios.post(FORMSPARK_ENDPOINT, {
    ...payload,
    _botpoison: solution
  });
};

export { FORMSPARK_ENDPOINT };

